import Service from '../service'
import HrPreviredNationality from '@/models/HumanResource/HrPreviredNationality'

export default class extends Service {
    static model = HrPreviredNationality
}
